var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center pt-5 pb-4",attrs:{"to":_vm.routePath}},[_c('v-icon',{staticClass:"mb-5",attrs:{"color":"primary","large":""}},[_vm._v(_vm._s(_vm.icon))]),_c('v-card-title',{staticClass:"pa-0 text-body-2 font-weight-bold default--text text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }